import React from 'react';
import {get, del} from '../../utils/request';
import {Spinner} from 'react-bootstrap';
import Alert from "../../component/Alert/Alert";
import Container from "../../component/Container/Container";
import Layout from "../../component/Layout/Layout";
import Link from "../../component/Link/Link";
import RoleNav from "../../component/RoleNav/RoleNav";
import DeleteRole from "./DeleteRole";
import {faArrowCircleLeft} from "@fortawesome/free-solid-svg-icons";
import "../../component/Table/Table.scss";
import './access.scss';

class RoleDeletePage extends React.Component {
    constructor(props) {
        super(props);
        const roleId = props.match.params.roleId;

        this.state = {
            roleId: roleId,
            roleName: '',
            errorMessage: "",
            loading: true,
            loadingSuccess: false
        };

        this.loadData = this.loadData.bind(this);
        this.deleteRole = this.deleteRole.bind(this);
    }

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        const [roleRes, roleErr] = await get(this, "/auth/role/" + this.state.roleId);
        if (roleErr) {
            this.setState({errorMessage: "error loading role: " + roleErr, loading: false});
            return;
        }
        this.setState({roleName: roleRes.data.Name, loading: false, loadingSuccess: true});
    }

    async deleteRole() {
        const roleName = this.state.roleName;
        const [_, err] = await del(this, "/auth/role/" + this.state.roleId);
        if (err) {
            this.setState({errorMessage: "error deleting role: " + err});
            return;
        }
        this.props.history.push({
            pathname: '/access',
            state: { successMessage: `Role "${roleName}" deleted successfully` }
        });
    }

    render() {
        const { roleId, roleName, loading, loadingSuccess, errorMessage } = this.state;
        return (
            <Layout activeMenu="/access" isLoggedIn={true}>
                <h1>Role <span className="entity-name">{roleName}</span></h1>

                {loading && (
                    <>
                        <Spinner animation="border" variant="primary"/> Loading...
                        <br/><br/>
                    </>
                )}

                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                {loadingSuccess && (
                    <>
                        <RoleNav roleId={roleId}/>
                        <Container>
                            <Alert variant="info">
                                Permanently delete this role and all associated S3 keys.
                            </Alert>
                            <table className="table-ctr">
                                <tbody>
                                    <tr>
                                        <td>
                                            <DeleteRole
                                                roleId={roleId}
                                                roleName={roleName}
                                                delete={this.deleteRole}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Container>
                        <div className="d-flex justify-content-end mt-3">
                            <Link
                                className="primary-outline btn btn-md mr3"
                                faIcon={faArrowCircleLeft}
                                href="/access"
                                label="Back to list"
                            />
                        </div>
                        <br/>
                        <Alert variant="info">
                            <b>For technical configurations, please consult our documentation</b> <br/>
                            <a href={`${process.env.REACT_APP_HOMEPAGE_URL}/resources/s3-api-permissions-and-compatibility`} target="_blank" rel="noopener">S3 API permissions and compatibility</a>
                        </Alert>
                    </>
                )}
            </Layout>
        );
    }
}

export default RoleDeletePage
